import { TprmRequirementType } from '@evidentid/tprm-portal-lib/models/entity-details';

import { AM_BEST_FINANCIAL_SIZE_CATEGORY_FIELD, AM_BEST_FINANCIAL_STRENGTH_RATING_FIELD } from '@/modules/document-data-review/constants/am-best';

import { FieldMeta } from '../../models/FieldMeta.model';
import { FieldSchema } from '../../models/FieldSchema.model';

import {
    createAdditionalInsuredEndorsementFieldMeta,
    createAddressFieldMeta,
    createCollateralFieldMeta,
    createCurrencyFieldMeta,
    createListFieldMeta,
    createScheduledOrBlanketFieldMeta,
    createSimpleFieldDefaultMeta,
} from './helpers';

function createMetaByPath(schema: FieldSchema): FieldMeta | null {
    if (schema.path === AM_BEST_FINANCIAL_SIZE_CATEGORY_FIELD) {
        return { ...schema, type: { $type: 'AmBestFinancialSizeCategory' }, defaultValue: undefined };
    }
    if (schema.path === AM_BEST_FINANCIAL_STRENGTH_RATING_FIELD) {
        return { ...schema, type: { $type: 'AmBestFinancialStrengthRating' }, defaultValue: undefined };
    }
    // converting currency string schema to Enum until we have permanent solution with BE
    if ((schema.path as string).toLowerCase().endsWith('currency')) {
        return createCurrencyFieldMeta(schema);
    }
    return null;
}

export function createFieldMetaFromSchema(
    schema: FieldSchema,
    context?: { requirementType?: TprmRequirementType },
): FieldMeta {
    const metaByPath = createMetaByPath(schema);
    if (metaByPath) {
        return metaByPath;
    }
    switch (schema.type.$type) {
        case 'Address':
            return createAddressFieldMeta(schema);
        case 'List':
            return createListFieldMeta(createFieldMetaFromSchema, schema, context);
        case 'Collateral':
            return createCollateralFieldMeta(schema, context?.requirementType);
        case 'AdditionalInsuredEndorsement':
            return createAdditionalInsuredEndorsementFieldMeta(schema);
        case 'ScheduledOrBlanket':
            return createScheduledOrBlanketFieldMeta(schema);
        default:
            return createSimpleFieldDefaultMeta(schema);
    }
}
